module.exports = __webpack_public_path__ + "img/医药WCA_01.95dce4d6.png";